module.exports = __webpack_public_path__ + "img/Leap Learning Lab - Guia de entrenamiento - 15.11.19.c5783d6b.png";